/*eslint no-loop-func: 0*/
/*eslint-env es6*/
import { fromJS, List, Map } from 'immutable';
//import { multiPolygon, polygon } from '@turf/helpers';
//import difference from '@turf/difference';

/* * * * * * * * * Adds all active carve-outs to the parcel feature layer * * * * * * * */
//const clipCarveOutsFromParcels = (state, action) => {
//  let mods = state.get('carveOuts').map(x => x.get('mod_tmks')).flatten().toSet().toList()

  // modify TMKs with a carve-out (clip)
  /*jshint loopfunc:true */
  /* var parcel, carve_outs, carve_out;
  let modifiedParcels = state.get('parcels').get('features').map(x => {
    if(mods.includes(x.get('properties').get('cty_tmk')) ) {
      carve_outs = state.get('carveOuts').filter(y => y.get('mod_tmks').includes(x.get('properties').get('cty_tmk'))).map(y => y.get('tmk')).toJS();
      if(x.get('geometry').get('type') === 'MultiPolygon') {
        parcel = multiPolygon(x.get('geometry').get('coordinates').toJS());
      } else {
        parcel = polygon(x.get('geometry').get('coordinates').toJS());
      }*/
      /*jshint loopfunc:true */
      /*for(var c = 0; c < carve_outs.length; c++) {
        carve_out = polygon(state.get('carveOutProperties').get('features').filter(z => z.get('properties').get('Name') === carve_outs[c]).get(0).get('geometry').get('coordinates').toJS());
        parcel = difference(parcel, carve_out);
      }
      return x.setIn(['geometry', 'coordinates'], fromJS(parcel['geometry']['coordinates']))
    } else {
      return x
    }
  })

  return state.set('modifiedParcels', modifiedParcels);
}

const carveOuts = [
  {'id': 0, 'active': true, 'area': 337, 'gisacres': 387.254, 'name': 'Hawaiian Cement Condominium', 'tmk': 'Hawaiian Cement Condominium Unit 1', 'mod_tmks': ['38004001', '38004002'], 'ex_tmks': [], fields: ['810', '811', '819'], list: "carveOutsCpr"},
  {'id': 1, 'active': true, 'area': 18,  'gisacres': 20.782, 'name': 'Maalaea D&C Landfill Condominium', 'tmk': 'Maalaea D&C Landfill Condominium Unit 1', 'mod_tmks': ['38005002'], 'ex_tmks': [], fields: ['906'], list: "carveOutsCpr"},
  {'id': 2, 'active': true, 'area': 328, 'gisacres': 288.885, 'name': 'HC&D Condominium', 'tmk': 'HC&D Condominium Unit 1', 'mod_tmks': ['38003004', '38003021', '38001001'], 'ex_tmks': [], fields: ['505', '511'], list: "carveOutsCpr"},
  {'id': 3, 'active': true, 'area': 5.3, 'gisacres': 3.716, 'name': 'Paia Store Village Condominium (Unit 1)', 'tmk': 'Paia Store Village Condominium Unit 1', 'mod_tmks': ['25005009', '25005020', '25005012'], 'ex_tmks': [], fields: ['207'], list: "carveOutsCpr"},
  {'id': 4, 'active': true, 'area': 3.4, 'gisacres': 3.546, 'name': 'Paia Store Village Condominium (Unit 2)', 'tmk': 'Paia Store Village Condominium Unit 2', 'mod_tmks': ['25005004', '25005020'], 'ex_tmks': ['25005052'], fields: [], list: "carveOutsCpr"},
  {'id': 5, 'active': true, 'area': 1.2, 'gisacres': 1.748, 'name': 'Paia Store Village Condominium (Unit 4)', 'tmk': 'Paia Store Village Condominium Unit 4', 'mod_tmks': ['25005020'], 'ex_tmks': [], fields: ['207'], list: "carveOutsCpr"},
  {'id': 6, 'active': true, 'area': 1.2, 'gisacres': 1.497, 'name': 'Paia Store Village Condominium (Unit 5)', 'tmk': 'Paia Store Village Condominium Unit 5', 'mod_tmks': ['25005020'], 'ex_tmks': [], fields: ['204'], list: "carveOutsCpr"},
  {'id': 7, 'active': true, 'area': 441, 'gisacres': 441.348, 'name': 'Kailua Plantation No. 1 Condominium (Unit 1)', 'tmk': 'Kailua Plantation No. 1 Condominium Unit 1', 'mod_tmks': ['25002001'], 'ex_tmks': [], fields: ['401'], list: "carveOutsCpr"},
  {'id': 8, 'active': true, 'area': 0.4, 'gisacres': 3.413, 'name': 'Kailua Plantation No. 2 Condominium (Unit 1)', 'tmk': 'Kailua Plantation No. 2 Condominium Unit 1 (Reservoir 32 CADE Station)', 'mod_tmks': ['25002002'], 'ex_tmks': [], fields: ['304'], list: "carveOutsCpr"},
  {'id': 9, 'active': true, 'area': 74,  'gisacres': 73.980, 'name': 'Puunene Mill Condominium (Unit 1)', 'tmk': 'Puunene Mill Condominium Unit 1', 'mod_tmks': ['38006001'], 'ex_tmks': [], fields: ['707'], list: "carveOutsCpr"},
  {'id': 10, 'active': true, 'area': 269, 'gisacres': 255.783, 'name': 'Puunene Mill Condominium (Unit 2)', 'tmk': 'Puunene Mill Condominium Unit 2', 'mod_tmks': ['38006001'], 'ex_tmks': ['38006013', '38006018', '38006051', '38006016'], fields: ['707', '711'], list: "carveOutsCpr"},
  {'id': 11, 'active': true, 'area': 27, 'gisacres': 27.289, 'name': 'Puu Nene 2 Condominium (Unit 1)', 'tmk': 'Puu Nene 2 Condominium Unit 1 (Cinder Pit & Debris)', 'mod_tmks': ['38001007'], 'ex_tmks': [], fields: ['611'], list: "carveOutsCpr"},
  {'id': 12, 'active': true, 'area': 1.0, 'gisacres': 2.942, 'name': 'McGerrow Condominium (Unit 1)', 'tmk': 'McGerrow Condominium Unit 1 (McGerrow Camp Cesspool)', 'mod_tmks': ['38006003'], 'ex_tmks': [], fields: ['714'], list: "carveOutsCpr"},
  {'id': 13, 'active': true, 'area': 20, 'gisacres': 25.019, 'name': 'Trap and Gun Condominium (Unit 1)', 'tmk': 'Trap and Gun Condominium Unit 1 (Maui Trap Club Shooting Range)', 'mod_tmks': ['25003031'], 'ex_tmks': [], fields: ['300','303','312'], list: "carveOutsCpr"},
  {'id': 14, 'active': true, 'area': 10, 'gisacres': 11.469, 'name': 'West Sunny Side Condominium (Unit 1)', 'tmk': 'West Sunny Side Condominium Unit 1 (Mud Dump (Paia))', 'mod_tmks': ['38003007', '38001006', '25003009'], 'ex_tmks': [], fields: ['206','209'], list: "carveOutsCpr"},
  {'id': 15, 'active': true, 'area': 3.0, 'gisacres': 4.430, 'name': 'West Sunny Side Condominium (Unit 2)', 'tmk': 'West Sunny Side Condominium Unit 2 (Field 602 CADE Station)', 'mod_tmks': ['38001006'], 'ex_tmks': [], fields: ['602'], list: "carveOutsCpr"},
  {'id': 16, 'active': true, 'area': 119, 'gisacres': 124.290, 'name': 'Central Maui Baseyard Condominium (Unit 2)', 'tmk': 'Central Maui Baseyard Condominium Unit 2', 'mod_tmks': ['38005001'], 'ex_tmks': ['38005019', '38005022'], fields: ['900'], list: "carveOutsCpr"},
  {'id': 17, 'active': true, 'area': 153, 'gisacres': 143.416, 'name': 'COEUS Condominium (Unit 1)', 'tmk': 'COEUS Condominium Unit 1', 'mod_tmks': ['38003002'], 'ex_tmks': [], fields: ['800', '806'], list: "carveOutsCpr"},
  {'id': 18, 'active': true, 'area': 26, 'gisacres': 25.211, 'name': 'Kaheka Condominium (Unit 1)', 'tmk': 'Kaheka Condominium Unit 1', 'mod_tmks': ['25005019','25005013'], 'ex_tmks': [], fields: ['213'], list: "carveOutsCpr"},
  {'id': 19, 'active': true, 'area': 17, 'gisacres': 16.761, 'name': 'Camp 5 Road Condominium (Unit 1)', 'tmk': 'Camp 5 Road Condominium Unit 1', 'mod_tmks': ['38006002'], 'ex_tmks': [], fields: ['717'], list: "carveOutsCpr"},
  {'id': 20, 'active': true, 'area': 189, 'gisacres': 182.946, 'name': 'Camp 5 Road Condominium (Unit 2)', 'tmk': 'Camp 5 Road Condominium Unit 2', 'mod_tmks': ['38006002'], 'ex_tmks': ['38006029', '38006015', '38006010'], fields: ['707', '708'], list: "carveOutsCpr"}
] */

/* * * * * * * * * PublicApp Reducer * * * * * * * * */
let initialState = Map({
  //"parcels": List(),
  "modifiedParcels": List(),
  "errorMessage": null,
  "mapCenter": [20.858, -156.405],
  "mapZoom":13,
  "mapBounds": null,
  "draggable":true,
  //"carveOutProperties": List(),
  //"carveOuts": fromJS(carveOuts)
  "fields_crops": List()
});

const PublicApp = (state = initialState, action) => {

  switch(action.type){

    case "VIEWPOINT_CHANGE":
      return state.set('mapCenter',action.viewpoint.center).set('mapZoom',action.viewpoint.zoom)

    /* * * * * * * * * ACTION RECEIVE DATA * * * * * * * * */
    case "ERROR":
      return state.set('errorMessage', action.message);

    case "CLEAR_ERROR_MESSAGE":
      return state.set('errorMessage', null);

    case "RECEIVE_PUBLIC_DATA":
      return state.set('fields_crops', fromJS(JSON.parse(action.data.fields_crops)))
        //.set('carveOutProperties', fromJS(JSON.parse(action.data.carveOuts)))
        //.set('parcels', fromJS(JSON.parse(action.data.parcels)))
        .set('errorMessage', null)

    case "INIT_PUBLIC_CARVE_OUTS":
      return state;
      //return clipCarveOutsFromParcels(state, action)

    case "RECENTER_MAP":
      return state.set("mapCenter", [20.808, -156.329]).set("mapZoom", 11)

    case "SET_MAP_BOUNDS":
      return state.set("mapBounds", action.bounds)

    default:
      return state;
  }
}

export default PublicApp;



// WEBPACK FOOTER //
// ./src/reducers/public.js